import React, {Component} from 'react'
import {PageStyle} from './../../../styles'

export default class Pages extends Component {
  state = {
    ready: false
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ ready: true })
    }, 400)
  }

  render () {
    const { children, title} = this.props
    const { ready } = this.state
    return (
      <div className={`page ${PageStyle(ready)}`}>
        <div className='page-inner'>
          <h2 className="page-title title">{title}</h2>
          <div className="page-container">
            {children}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Page.js